import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { TableColumn } from '../../../../components/tables/Table'
import { useBuckets } from '../_load/BucketsLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import EditableBucket from '../../../../containers/buckets/EditableBucket'
import Icon from '../../../../components/shapes/Icon'
import Link from '../../../../components/actions/Link'

const BucketsTable = () => {
  const { t } = useTranslation('listBuckets')
  const data = useBuckets()

  const columns = [
    {
      label: t('name'),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 2,
      render: (value, record) => (
        <EditableBucket record={record} field="name">
          <TableColumn>{value}</TableColumn>
        </EditableBucket>
      )
    },

    {
      label: t('qrcodes'),
      dataIndex: 'qrcodesCount',
      sortIndex: false,
      flex: 1
    },

    {
      label: t('date'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },

    {
      label: t('pdf'),
      dataIndex: 'id',
      sortIndex: false,
      flex: 1,
      render: (data, record, index) => (
        <Link to={`/buckets/${data}/pdf`}>
          <Icon name="BsFileEarmarkBreak" size="1rem" color={COLORS.purple} />
        </Link>
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default BucketsTable
